import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("footer");
  }

  toggleTheme() {
    const html = document.documentElement;
    const isDark = html.classList.toggle("dark");
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }
}
